module.exports = __webpack_public_path__ + "img/ico_service_arw_down.d54fc4ee.svg";